export default __webpack_public_path__ + "static/media/calculator.eea76219.png";